/**
 * Where a notification takes a member of staff in the CRM. Staff receive four kinds
 * (payment proof uploaded, client assigned, client inactive, plan ending) plus chat;
 * anything else has no screen and only marks read.
 *
 * The links never carry more than an id the reader can already see: RLS decides what the
 * target screen shows (a trainer following a stale "client assigned" to a member who was
 * reassigned gets Not found, not the member).
 */
import type { Role } from '@/auth/roles';

export interface NotificationLike {
  type: string;
  data: unknown;
}

function str(data: unknown, key: string): string | null {
  if (!data || typeof data !== 'object') return null;
  const value = (data as Record<string, unknown>)[key];
  return typeof value === 'string' && value !== '' ? value : null;
}

export function crmLinkFor(n: NotificationLike, role: Role): string | null {
  const client = str(n.data, 'client_id');
  switch (n.type) {
    case 'payment_submitted': {
      if (role !== 'owner' && role !== 'admin') return null;
      const payment = str(n.data, 'payment_id');
      return payment ? `/payments/queue?id=${encodeURIComponent(payment)}` : '/payments/queue';
    }
    case 'client_assigned':
    case 'client_inactive':
      return client ? `/clients/${encodeURIComponent(client)}` : '/clients';
    case 'plan_ending':
      return client ? `/clients/${encodeURIComponent(client)}?tab=workout` : '/plans';
    case 'chat_message':
      return client ? `/messages?client=${encodeURIComponent(client)}` : '/messages';
    default:
      return null;
  }
}
